import jsCookie from 'js-cookie'

//系统来源：1 pop商家工作台 2 育儿商家工作台 3 成长加商家工作台 4 供应商工作台 5 商客合一工作台 
const SYSTEM_SOURCE = {
  1: 1,
  2: 1,
  3: 4,
  4: 4,
  5: 2,
  6: 3,
}
export default class SubmitCommitParam {
  // 吐槽 scene_id = 1 举报 scene_id = 2
  scene_id = 1
  
  // 全局来源 1-Android   2-ios    3-H5   4-wx  5-pc
  source = 5
  constructor ({ category_id, category_name, content, img_url = [], mobile_phone, qq, anonymous_switch }) {
    // 全局分类id
    this.category_id = category_id
    // 内容
    if (content) {
      this.content = content
    }
    this.system_source = SYSTEM_SOURCE[jsCookie.get('buzzType')]
    this.img_url = [...img_url]
    this.anonymous_switch = anonymous_switch
    // console.log(category_name)
    try {
      this.ext_field = JSON.stringify({ category_name, mobile_phone, qq })
    } catch (e) {
      console.error(e)
    }
  }
}
